<mat-sidenav-container class="sidenav-container">

  <mat-sidenav-content>
    <mat-toolbar color="primary" class="toolbar">
      <!--<a class="title-page" [routerLink]="['/admin']">
        <mat-icon>dashboard</mat-icon>
        {{'menu.admin.dashboard'|traduccion}}
      </a>-->
      <!--<span class="spacer"></span>-->
      <!-- Menú de escritorio -->
      <nav class="nav-links">
        <a *appShowForRoles="['ROLE_ADMIN', 'ROLE_SUPERMANAGER']" mat-button class="nav-link" [routerLink]="['dashboard']">
          <mat-icon>dashboard</mat-icon>
          {{'menu.admin.dashboard'|traduccion}}
        </a>
        <a *appShowForRoles="['ROLE_ADMIN', 'ROLE_SUPERMANAGER']" mat-button class="nav-link" [routerLink]="['company']">
          <mat-icon>store</mat-icon>
          {{'menu.admin.company'|traduccion}}
        </a>
        <a *appShowForRoles="['ROLE_ADMIN', 'ROLE_SUPERMANAGER']" mat-button class="nav-link" [routerLink]="['user']">
          <mat-icon>group</mat-icon>
          {{'menu.admin.user'|traduccion}}
        </a>
        <a *appShowForRoles="['ROLE_ADMIN', 'ROLE_MANAGER']" mat-button class="nav-link" [routerLink]="['reservation']">
          <mat-icon>confirmation_number</mat-icon>
          {{'menu.admin.reservation'|traduccion}}
        </a>

        <button *appShowForRoles="['ROLE_ADMIN', 'ROLE_SUPERMANAGER']" mat-button [matMenuTriggerFor]="financeMenu">
          <mat-icon>bar_chart</mat-icon>
          {{'menu.admin.finance'|traduccion}}
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #financeMenu="matMenu">
          <button mat-menu-item [routerLink]="['payments']">
            <mat-icon>payments</mat-icon>
            {{'menu.admin.finance.payment'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['invoice']">
            <mat-icon>receipt</mat-icon>
            {{'menu.admin.finance.invoice'|traduccion}}
          </button>
        </mat-menu>

        <button *appShowForRoles="['ROLE_ADMIN', 'ROLE_SUPERMANAGER']" mat-button [matMenuTriggerFor]="lockerMenu">
          <mat-icon>kitchen</mat-icon>
          {{'menu.admin.locker'|traduccion}}
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #lockerMenu="matMenu">
          <button *appShowForRoles="['ROLE_ADMIN']" mat-menu-item [routerLink]="['category']">
            <mat-icon>category</mat-icon>
            {{'menu.admin.locker.category'|traduccion}}
          </button>
          <button *appShowForRoles="['ROLE_ADMIN']" mat-menu-item [routerLink]="['product']">
            <mat-icon>grid_view</mat-icon>
            {{'menu.admin.locker.product'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['locker']">
            <mat-icon>border_outer</mat-icon>
            {{'menu.admin.locker.box'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['discount']">
            <mat-icon>money_off</mat-icon>
            {{'menu.admin.locker.discount'|traduccion}}
          </button>
        </mat-menu>

        <a mat-button class="nav-link" [routerLink]="['maintenance']">
          <mat-icon>assignment</mat-icon>
          {{'menu.admin.maintenance'|traduccion}}
        </a>
        <button *appShowForRoles="['ROLE_ADMIN']" mat-button [matMenuTriggerFor]="configurationMenu">
          <mat-icon>settings</mat-icon>
          {{'menu.admin.configuration'|traduccion}}
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #configurationMenu="matMenu">
          <button mat-menu-item [routerLink]="['sender']">
            <mat-icon>send</mat-icon>
            {{'menu.admin.configuration.sender'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['payment-provider']">
            <mat-icon>credit_card_gear</mat-icon>
            {{'menu.admin.configuration.paymentProvider'|traduccion}}
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item [routerLink]="['literal']">
            <mat-icon>language</mat-icon>
            {{'menu.admin.configuration.literal'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['config']">
            <mat-icon>build</mat-icon>
            {{'menu.admin.configuration.config'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['setting-fiscal']">
            <mat-icon>storefront</mat-icon>
            Configuracion fiscal
          </button>
          <button mat-menu-item [routerLink]="['loggers']">
            <mat-icon>list_alt</mat-icon>
            {{'menu.admin.configuration.loggers'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['pool']">
            <mat-icon>format_list_numbered</mat-icon>
            {{'menu.admin.configuration.pool'|traduccion}}
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item [routerLink]="['schedule']">
            <mat-icon>schedule</mat-icon>
            {{'menu.admin.configuration.schedule'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['pending-event']">
            <mat-icon>event_busy</mat-icon>
            {{'menu.admin.configuration.pendingEvent'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['worker-manager']">
            <mat-icon>engineering</mat-icon>
            {{'menu.admin.configuration.workerManager'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['kiosk-sync']">
            <mat-icon>sync_problem</mat-icon>
            {{'menu.admin.configuration.kioskSync'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="['admin-kiosk']">
            <mat-icon>storage</mat-icon>
            DB KIOSK
          </button>
        </mat-menu>

      </nav>
    </mat-toolbar>

  </mat-sidenav-content>
</mat-sidenav-container>
